import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNimComponent } from './simple-icons-nim.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNimComponent ],
    exports:      [ SimpleIconsNimComponent ],
    bootstrap:    []
})
export class SimpleIconsNimModule {}
